import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const detailsWrapper = css`
  margin-inline-start: ${spacing(6)};
  margin-inline-end: ${spacing(1)};
`

export const inputsWrapper = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 8px;
`

export const suggest = css`
  margin-inline-start: 8px;
  width: auto;
  ::before {
    content: none;
  }
`
